module.exports = __webpack_public_path__ + "static/img/mapicongreen.0b502300.png";